import { render, staticRenderFns } from "./BigLandOwners.vue?vue&type=template&id=1b423c5e&"
import script from "./BigLandOwners.vue?vue&type=script&lang=js&"
export * from "./BigLandOwners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports